export default [
  {
    key: 'remark',
    label: 'label.remark',
    // hint: 'label.cancelRemarkHint',
    type: 'textarea',
    rules: 'required|min:2|max:1000',
    rows: '5',
    cols: 12,
  },
]
